import React, { useState, useEffect, useRef } from "react";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";
import { appLogo } from "../../../config/appConfig";

const Header = ({onSuccess}) => {

  const navigate = useNavigate();

  const handleLogout = () => {
    // console.log(":inside logout");
    sessionStorage.clear()
    sessionStorage.clear()
    // onSuccess()
    navigate("/");
    window.location.reload(false)
  };

  return (
    <>
      <div className="app-header header-shadow">
        <div className="app-header__logo">
          <div className=""> <img src={appLogo} style={{ width: "150px" }} /> </div>
          <div className="header__pane ml-auto">
            <div>
              <button type="button" className="hamburger close-sidebar-btn hamburger--elastic" >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="app-header__mobile-menu">
          <div>
            <button type="button" className="hamburger hamburger--elastic mobile-toggle-nav">
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
        <div className="app-header__menu">
          <span>
            <button type="button" className="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
              <span className="btn-icon-wrapper">
                <i className="fa fa-ellipsis-v fa-w-6"></i>
              </span>
            </button>
          </span>
        </div>
        <div className="app-header__content">
          <div className="app-header-right">
            <div className="header-btn-lg pr-0">
              <div className="widget-content p-0">
                <div className="widget-content-wrapper">
                  <div className="widget-content-left">
                    <div className="btn-group">
                      {/* <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="p-0 btn">
                          <img width="42" className="rounded-circle" src="assets/images/avatars/1.jpg" alt="" />
                          <i className="fa fa-angle-down ml-2 opacity-8"></i>
                        </a> */}
                      <div onClick={() => handleLogout()} className="d-flex font-style" style={{ "alignItems": "center" }}>
                        <span>Logout</span>
                        <FontAwesomeIcon className="p-2 m-auto logout btn-outline-light font-style" icon={faSignOut} />
                      </div>
                      {/* <div tabindex="-1" role="menu" aria-hidden="true" className="dropdown-menu dropdown-menu-right">
                          <button type="button" tabindex="0" className="dropdown-item">Logout</button>
                        </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header